import { createContext, ReactNode, useContext, useEffect, useState } from "react";
import { useCartStore, type CartReconciliationReason } from "@ecommerce/cart";
import { httpClient } from "../http/client";

const PricingSessionContext = createContext(0);
const VODA_TOKEN_STORAGE_KEY = "voda-argentina-tokens";

interface PricingSessionProviderProps {
    children: ReactNode;
}

export function PricingSessionProvider({ children }: PricingSessionProviderProps) {
    const [revision, setRevision] = useState(0);

    useEffect(() => {
        const reconcile = async (reason: CartReconciliationReason) => {
            try {
                await useCartStore.getState().reconcilePrices(reason);
            } catch (error) {
                console.error(`No se pudo reconciliar el carrito por ${reason}.`, error);
            }
        };

        const unsubscribe = httpClient.subscribeSessionChanged((event) => {
            setRevision((current) => current + 1);
            /*
             * No se espera esta promesa: un refresh puede haber sido iniciado
             * por la propia request de reconciliación. Esperarla desde el
             * evento produciría un ciclo refresh -> listener -> request.
             */
            void reconcile(event.type);
        });

        const handleStorage = (event: StorageEvent) => {
            if (event.key !== VODA_TOKEN_STORAGE_KEY) return;

            httpClient.updateAuthHeader();
            setRevision((current) => current + 1);
            void reconcile(event.newValue ? "REFRESH" : "LOGOUT");
        };

        window.addEventListener("storage", handleStorage);
        void reconcile("BOOTSTRAP");

        return () => {
            unsubscribe();
            window.removeEventListener("storage", handleStorage);
        };
    }, []);

    return (
        <PricingSessionContext.Provider value={revision}>{children}</PricingSessionContext.Provider>
    );
}

export function usePricingSessionRevision() {
    return useContext(PricingSessionContext);
}
